import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import CarouselViewAllLink from 'components/Common/CarouselViewAllLink'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { getIsEnabledLuxPlusDiscountedCruise } from 'luxPlus/selectors/featureToggle'
import { useAppSelector } from 'hooks/reduxHooks'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'

const searchFilters: App.OfferListFilters = {
  hasLuxPlusPrice: true,
}

const offerFilters: App.OfferListFilters = {
  ...CRUISE_BANK_OFFERS_FILTERS,
  ...searchFilters,
  sortBy: 'luxPlusList',
}

function CruisePageLuxPlusOffersCarousel() {
  const intl = useIntl()
  const isEnabledLuxPlusDiscountedCruise = useAppSelector(getIsEnabledLuxPlusDiscountedCruise)
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isHidden = !isEnabledLuxPlusDiscountedCruise || currentRegionCode === 'NZ'

  const offerList = useOfferList(offerFilters, { disabled: isHidden })

  const viewAllLabel = intl.formatMessage({
    id: 'd5sMgD_zUi47GCj-MoXy',
    defaultMessage: 'View all',
    description: 'Action button label to view all LuxPlus+ discounted cruise offers',
  })

  if (isHidden || (!offerList.fetching && !offerList.offerIds.length)) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="VZ-FCnR4aC0tB9Du2nsU"
            defaultMessage="Save more with exclusive LuxPlus+ discounts"
            description="Section heading for LuxPlus+ discounted cruise offers carousel on the main cruises landing page"
          />
        </Heading>

        <CarouselViewAllLink
          to={`/search/cruises?${qs.stringify(searchFilters, { arrayFormat: 'repeat' })}`}
        >
          {viewAllLabel}
        </CarouselViewAllLink>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageLuxPlusOffersCarousel
